import { all, call, put, takeLatest } from 'redux-saga/effects';

import { httpService, request } from '@app/services';
import { setToken } from '@app/modules/common';
import { prepareUserSessionSaga } from '../bootstrap';
import * as endpoints from './endpoints';
import {
  login,
  loginSuccess,
  loginFailed,
  forgotPassword,
  forgotPasswordSuccess,
  forgotPasswordFailed,
  setPassword,
  setPasswordSuccess,
  setPasswordFailed,
  signUp,
  signUpFailed,
  signUpSuccess,
} from './slice';

// ------------------------------------------------------

function* loginSaga(action: ReturnType<typeof login>): any {
  try {
    const { email, password } = action.payload;
    const response = yield call(request.post, endpoints.signIn, {
      email,
      password,
    });

    yield put(loginSuccess(response.data));
    yield put(setToken(response.token));
    yield call(prepareUserSessionSaga);
  } catch (error: any) {
    yield put(loginFailed(error));
  }
}

function* signUpSaga({ payload }: ReturnType<typeof signUp>): any {
  try {
    const { name, email, password } = payload;

    const response = yield call(request.post, endpoints.signUp, {
      email: email,
      name,
      password,
    });

    yield put(signUpSuccess(response?.data));
  } catch (error: any) {
    yield put(signUpFailed(error));
  }
}

function* forgotPasswordSaga(action: ReturnType<typeof forgotPassword>): any {
  try {
    const { email } = action.payload;
    const data = yield call(request.post, endpoints.forgotPassword, {
      email,
      platform: 'Web',
    });
    yield put(forgotPasswordSuccess(data));
  } catch (error: any) {
    yield put(forgotPasswordFailed(error));
  }
}
function* setPasswordSaga(action: ReturnType<typeof setPassword>): any {
  try {
    const { password, token } = action.payload;

    httpService.setToken(token ?? null);
    const data = yield call(request.put, endpoints.setPassword, {
      password,
    });
    yield put(setPasswordSuccess(data));
  } catch (error: any) {
    yield put(setPasswordFailed(error));
    httpService.setToken(null);
  }
}

function* authSagas() {
  yield all([
    takeLatest(login, loginSaga),
    takeLatest(signUp, signUpSaga),
    takeLatest(forgotPassword, forgotPasswordSaga),
    takeLatest(setPassword, setPasswordSaga),
  ]);
}

export { authSagas };
